import React from 'react';
import { JRCFormFieldRenderer } from '../Common/JRCFormFieldRenderer';
import { JRCInputSelectProps } from './JRCInputSelect.types';
import type { FieldValues } from 'react-hook-form';
import { JRCInputSelectRaw } from './JRCInputSelectRaw';

export function JRCInputSelectExtended<T extends FieldValues = FieldValues>(props: JRCInputSelectProps<T>) {
    const {
        name,
        control,
        readOnly,
        rules,
        label,
        htmlFor,
        labelIsLegend,
        description,
        helper,
        width,
        margin,
        size,
        labelMargin,
    } = props;

    return (
        <JRCFormFieldRenderer
            name={name}
            control={control}
            readOnly={readOnly}
            rules={rules}
            label={label}
            htmlFor={htmlFor ?? name}
            labelIsLegend={labelIsLegend}
            description={description}
            helper={helper}
            width={width}
            margin={margin}
            labelMargin={labelMargin}
            noLabel={props.noLabel}
            renderFunction={(field) => (
                <JRCInputSelectRaw
                    {...props}
                    htmlFor={htmlFor ?? name}
                    {...field}
                    required={!!props.rules?.required}
                    size={size ?? 'md'}
                />
            )}
        />
    );
}
